import PropTypes from 'prop-types';

// TODO: for some reason graphql is returning the wrong format
// I should check this and find a proper way

export default PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.oneOf([
    'multiple_selection',
    'simple_selection',
    'true_or_false',
  ]),
]);
